import * as React from "react";

function Dashboard(props) {
  return (
    <svg width={22} height={22} fill="none" {...props}>
      <rect
        x={1}
        y={1}
        width={8}
        height={8}
        rx={4}
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        clipRule="evenodd"
        d="M13 5a4 4 0 014-4v0a4 4 0 014 4v0a4 4 0 01-4 4v0a4 4 0 01-4-4v0zM13 17a4 4 0 014-4v0a4 4 0 014 4v0a4 4 0 01-4 4v0a4 4 0 01-4-4v0zM1 17a4 4 0 014-4v0a4 4 0 014 4v0a4 4 0 01-4 4v0a4 4 0 01-4-4v0z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

const DashboardIcon = React.memo(Dashboard);
export default DashboardIcon;
